import { render, staticRenderFns } from "./FooterCta.vue?vue&type=template&id=2965cb01&"
import script from "./FooterCta.vue?vue&type=script&lang=ts&"
export * from "./FooterCta.vue?vue&type=script&lang=ts&"
import style0 from "./FooterCta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
